import enUS from '@/locales/en-US';
import jaJP from '@/locales/ja-JP';
import ptPT from '@/locales/pt-PT';
import zhCN from '@/locales/zh-CN';
import { normalizeLocale } from '@/shared/i18n/normalizeLocal';
import { SupportedLocale } from '@/shared/i18n/SupportedLocale';
import { Any } from '../constant/any';
import { i18nParamReplace } from './i18nParamReplace';

export type LocaleType = typeof enUS | typeof jaJP | typeof ptPT | typeof zhCN;

export const allLocaleConfig: Record<SupportedLocale, LocaleType> = {
  [SupportedLocale.EN_US]: enUS,
  [SupportedLocale.ZH_CN]: !IS_GLOBAL ? zhCN : Any,
  [SupportedLocale.JA_JP]: IS_GLOBAL ? jaJP : Any,
  [SupportedLocale.PT_PT]: IS_GLOBAL ? ptPT : Any,
};

export function i18n(
  key: keyof LocaleType,
  locale: SupportedLocale,
  params: Record<string, string> = {},
) {
  const currentLocale = normalizeLocale(locale);

  const result =
    i18nParamReplace(
      allLocaleConfig[currentLocale][key] ?? allLocaleConfig[SupportedLocale.EN_US][key] ?? '',
      params,
    ) ?? key;

  return result;
}
